// extracted by mini-css-extract-plugin
export default {"chat":"style_chat__6AwHC","message":"style_message__rRrGG","input":"style_input__NPk8t","prefix":"style_prefix__F-8Am","suffix":"style_suffix__XV9HO"};